import React from "react";
import {
  Phone,
  EnvelopeSimple,
  MapPin,
  Clock,
  WhatsappLogo,
  CalendarBlank,
} from "phosphor-react";
import "./contactUs.css";

const ContactUs = () => {
  return (
    <div className="contact-page">

      {/* Header */}

      <div className="contact-header">
        <p className="contact-subtitle">
          PURECARATS CONCIERGE
        </p>

        <h2>We're Here To Help</h2>

        <p className="contact-description">
          Whether you have a question about your order, wish to book an
          appointment, or need jewellery assistance, our team is always happy to
          help.
        </p>
      </div>

      {/* Contact Cards */}

      <div className="contact-grid">

        <div className="contact-card">
          <Phone
            size={32}
            weight="light"
            className="contact-icon"
          />

          <h4>Call Us</h4>

          <p>+91 8850286201</p>

          <span>Mon - Sat | 10:30 AM - 7:30 PM</span>
        </div>

        <div className="contact-card">
          <WhatsappLogo
            size={32}
            weight="light"
            className="contact-icon"
          />

          <h4>WhatsApp</h4>

          <p>Chat with our Jewellery Expert</p>

          <a
            href="https://wa.me/918850286201"
            target="_blank"
            rel="noreferrer"
          >
            Chat Now →
          </a>
        </div>

        <div className="contact-card">
          <EnvelopeSimple
            size={32}
            weight="light"
            className="contact-icon"
          />

          <h4>Email</h4>

          <p>info.purecarats@gmail.com</p>

          <span>Replies within 24 Hours</span>
        </div>

        <div className="contact-card">
          <MapPin
            size={32}
            weight="light"
            className="contact-icon"
          />

          <h4>Experience Studio</h4>

          <p>Malad East, Mumbai</p>

          <a
            href="https://google.com/maps?vet=10CAAQoqAOahcKEwi4j9C6kaWVAxUAAAAAHQAAAAAQCw..i&rlz=1C5CHFA_enIN1046IN1046&pvq=Cg0vZy8xMXFwd21iazlxIhMKDWRyZWFtcyBqZXdlbHMQAhgD&lqi=Cg1kcmVhbXMgamV3ZWxzWhciDWRyZWFtcyBqZXdlbHMqBggCEAAQAZIBFGpld2VscnlfbWFudWZhY3R1cmVy&fvr=1&cs=0&um=1&ie=UTF-8&fb=1&gl=in&sa=X&ftid=0x3be7b708a1dea0d7:0x5c142c844bbcac57"
            target="_blank"
            rel="noreferrer"
          >
            Get Directions →
          </a>
        </div>

      </div>

      {/* Quick Help */}

      <div className="quick-help">

        {/* <h3>How Can We Help?</h3>

        <div className="">

          <button className="help-button">Book Appointment</button>

          <button>Track My Order</button>

          <button>Custom Jewellery</button>

          <button>Jewellery Care</button>

          <button>Returns & Exchange</button>

          <button>FAQs</button>

        </div> */}

      </div>

      {/* Footer */}

      <div className="contact-footer">

        <div className="footer-item">
          <Clock
            size={20}
            weight="light"
          />

          <span>
            Monday - Saturday &nbsp; | &nbsp; 10:30 AM - 7:30 PM
          </span>
        </div>

        <div className="footer-item">
          <CalendarBlank
            size={20}
            weight="light"
          />

          <span>
            By Appointment Only
          </span>
        </div>

      </div>

    </div>
  );
};

export default ContactUs;